import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedSouthPoleLayer() {
  if (hasYamlRight('southPole')) return {}

  const southPoleUrl = RIGHTS('map.layers.southPole.url', '')

  if (!southPoleUrl) return {}

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    type: 'tileWMS',
    url: southPoleUrl,
    data: { icon: 'southPole' },
    params: {
      TRANSPARENT: true,
      LAYERS: 'cls:noaa_blue_marble_south_pole',
    },
    //crossOrigin: 'anonymous',
    projection: 'EPSG:32761',
    maxZoom: 8 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
    tileSize: 512,
  }
}
